import equal from "fast-deep-equal/es6";

type IDirtyDiffArg = Record<string, any>;

const innerDiff = (
    a: IDirtyDiffArg,
    b: IDirtyDiffArg,
    shallow: boolean = true,
): string[] => {
    const dirtyKeys: string[] = [];

    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length < bKeys.length) {
        return innerDiff(b, a, shallow);
    }
    Object.keys(a).forEach(k => {
        if (!equal(a[k], b[k])) {
            dirtyKeys.push(k);
            if (
                !shallow &&
                a[k] &&
                b[k] &&
                typeof a[k] === "object" &&
                typeof b[k] === "object"
            ) {
                const deepKeys = innerDiff(a[k], b[k], shallow);
                deepKeys.forEach(i => dirtyKeys.push(`${k}.${i}`));
            }
        }
    });
    return dirtyKeys;
};

export const dirtyDiff = (
    a: IDirtyDiffArg = {},
    b: IDirtyDiffArg = {},
    shallow: boolean = true,
): string[] => {
    a = JSON.parse(JSON.stringify(a));
    b = JSON.parse(JSON.stringify(b));
    return innerDiff(a, b, shallow);
};
